export default __webpack_public_path__ + "static/media/dr_kiss_logo-right.4e8095df.svg";